import { List } from 'immutable';
import { DesignTemplates } from 'records/DesignTemplate';
import BaseList from 'records/BaseList';

import {
  SEARCH_BG_TEMPLATES_ASYNC_ACTION_START,
  SEARCH_BG_TEMPLATES_ASYNC_ACTION_ERROR,
  SEARCH_BG_TEMPLATES_ASYNC_ACTION_SUCCESS,
  SEARCH_BG_TEMPLATES_RESET_STATE,
  SEARCH_BG_RESULT_TEMPLATES_SEARCH_KEY_VAL,
} from 'actions/searchBgDesignTemplates';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [SEARCH_BG_TEMPLATES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [SEARCH_BG_TEMPLATES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [SEARCH_BG_TEMPLATES_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: DesignTemplates(action.data),
    });
  },
  [SEARCH_BG_TEMPLATES_RESET_STATE]: () => {
    return initialState;
  },
  [SEARCH_BG_RESULT_TEMPLATES_SEARCH_KEY_VAL]: (state, action) => {
    return state.merge({
      sortKey: action.data,
    });
  },

};

export default function searchBgDesignTemplates(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
